<template>
  <div class="p-3">
    <b-form>
      <b-overlay :show="busy" opacity="0.1" rounded="sm">
        <!-- Dados Principais do Destinatário / Remetente -->
        <div class="premium-card shadow-sm mb-4">
          <div class="card-header-premium">
            <i class="fa fa-user mr-2"></i> DADOS DO DESTINATÁRIO / REMETENTE
          </div>
          <div class="p-3">
            <b-row>
              <b-col md="6">
                <b-form-group label="* Destinatário" label-for="id_dest" class="premium-form-group">
                  <cliente-pesquisa
                    @retornaId="onClienteRetornaId"
                    @retornaNome="onClienteRetornaNome"
                    @retornaCGC="onClienteRetornaCGC"
                    :idInicial="nfe.ID_CLIENTE_NFE ? Number(nfe.ID_CLIENTE_NFE) : undefined"
                    :classe-required="true"
                    :desabilitarInput="isLoadingFromBackend || !podeEditar"
                    idModal="modalDestinatario"
                    id="edID_DEST"
                    ref="edID_DEST"
                    place="Informe o Destinatário (F2 para pesquisar)"
                    labelBotao=""
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="* Tipo" label-for="tipo_doc" class="premium-form-group">
                  <b-form-select
                    id="tipo_doc"
                    v-model="nfe.OP_TIPO_DOC_DEST"
                    :options="tipoDocOptions"
                    class="rounded-pill"
                    @change="onTipoDocChange"
                    :disabled="!podeEditar"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="* CNPJ/CPF" label-for="cnpjcpf" class="premium-form-group">
                  <b-form-input
                    id="cnpjcpf"
                    v-model="nfe.TX_NUM_CNPJ_DEST"
                    :required="true"
                    :placeholder="cnpjCpfPlaceholder"
                    inputmode="numeric"
                    maxlength="14"
                    class="rounded-pill"
                    @blur="onCgcBlur"
                    :disabled="!podeEditar"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Tipo Contribuinte" label-for="tipo_contrib" class="premium-form-group">
                  <b-form-select
                    id="tipo_contrib"
                    v-model="nfe.OP_ICMS_ISENTO_DEST"
                    :options="tipoContribOptions"
                    class="rounded-pill"
                    @change="onTipoContribChange"
                    :disabled="!podeEditar"
                  />
                </b-form-group>
              </b-col>
            
              <b-col md="3">
                <b-form-group label="* Inscrição Estadual" label-for="ie" class="premium-form-group">
                  <b-form-input
                    id="ie"
                    v-model="nfe.TX_NUM_IE_DEST"
                    class="rounded-pill"
                    :disabled="!podeEditar || nfe.OP_ICMS_ISENTO_DEST === '1'"
                    maxlength="14"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Inscrição SUFRAMA" label-for="suframa" class="premium-form-group">
                  <b-form-input id="suframa" v-model="nfe.TX_NUM_SUFRAMA_DEST" maxlength="9" class="rounded-pill" :disabled="!podeEditar" />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Email" label-for="email" class="premium-form-group">
                  <b-form-input
                    id="email"
                    v-model="nfe.TX_EMAIL_DEST"
                    type="email"
                    maxlength="60"
                    class="rounded-pill"
                    :disabled="!podeEditar"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>

        <!-- Endereço Principal -->
        <div class="premium-card shadow-sm mb-4">
          <div class="card-header-premium">
            <i class="fa fa-map-marker mr-2"></i> ENDEREÇO PRINCIPAL
          </div>
          <div class="p-3">
            <b-row>
              <b-col md="6">
                <b-form-group label="Logradouro" label-for="logradouro" class="premium-form-group">
                  <b-form-input id="logradouro" v-model="nfe.TX_LOGRADOURO_DEST" :disabled="!podeEditar" maxlength="60" class="rounded-pill" />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Número" label-for="numero" class="premium-form-group">
                  <b-form-input id="numero" v-model="nfe.TX_NUMERO_DEST" maxlength="60" class="rounded-pill" :disabled="!podeEditar" />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Complemento" label-for="complemento" class="premium-form-group">
                  <b-form-input id="complemento" v-model="nfe.TX_COMPLEMENTO_DEST" maxlength="60" class="rounded-pill" :disabled="!podeEditar" />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label="* Bairro" label-for="bairro" class="premium-form-group">
                  <b-form-input id="bairro" v-model="nfe.TX_BAIRRO_DEST" maxlength="60" class="rounded-pill" :disabled="!podeEditar" />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="País" label-for="pais" class="premium-form-group">
                  <b-form-input id="pais" v-model="nfe.TX_PAIS_DEST" readonly class="rounded-pill" />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="UF" label-for="uf" class="premium-form-group">
                  <b-form-select
                    id="uf"
                    v-model="nfe.ID_UF_DEST"
                    :options="ufOptions"
                    class="rounded-pill"
                    @change="onUfChange"
                    :disabled="!podeEditar || busy"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Município" label-for="municipio" class="premium-form-group">
                  <b-form-select
                    id="municipio"
                    v-model="nfe.ID_MUNICIPIO_DEST"
                    :options="municipioOptions"
                    class="rounded-pill"
                    :disabled="!podeEditar || municipiosBusy || !nfe.ID_UF_DEST"
                    @change="emitInput"
                  />
                  <small v-if="municipiosBusy" class="text-muted ml-2">Carregando municípios...</small>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="CEP" label-for="cep" class="premium-form-group">
                  <b-form-input id="cep" v-model="nfe.TX_CEP_DEST" inputmode="numeric" placeholder="00000-000" class="rounded-pill" :disabled="!podeEditar" />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Fone" label-for="fone" class="premium-form-group">
                  <b-form-input id="fone" v-model="nfe.TX_FONE_DEST" inputmode="tel" placeholder="(00) 0000-0000" class="rounded-pill" :disabled="!podeEditar" />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'NfeAbaDestinatario',
  props: {
    nfe: { type: Object, required: true },
    // Flag do componente pai indicando que está carregando dados do backend
    // Quando true, este componente NÃO deve executar ações automáticas (watchers, eventos, etc)
    isLoadingFromBackend: { type: Boolean, default: false },
    podeEditar: { type: Boolean, default: false }
  },
  data () {
    return {
      busy: false,
      readonlyFromMaster: false,
      // previous destinatário id and uf (used to validate changes like Delphi form)
      _prevDestId: (this.nfe && this.nfe.ID_CLIENTE_NFE) || '',
      _prevDestUf: (this.nfe && this.nfe.ID_UF_DEST) || '',
      // municipios helper (behaviour similar to ClientesEdit.vue)
      municipios: [],
      municipiosBusy: false,
      // placeholder option shown until estados are loaded
      ufOptions: [{ value: '', text: 'Selecione a UF' }],
      tipoDocOptions: [
        // origem: Unt_NotaFiscalEletronica.dfm: ComboOP_TIPO_DOC_DEST
        { value: '0', text: 'CPF - Física' },
        { value: '1', text: 'CNPJ - Jurídica' },
        { value: '2', text: 'Exportação - Não exige docs' }
      ],
      tipoContribOptions: [
        // origem: Unt_NotaFiscalEletronica.dfm: comboOP_ICMS_ISENTO_DEST
        { value: '0', text: 'Contribuinte' },
        { value: '1', text: 'Isento' },
        { value: '2', text: 'Não Contribuinte' }
      ]
    }
  },
  components: {
    ClientePesquisa: () => import('@/views/pesquisa/ClientePesquisa.vue')
  },
  watch: {
    nfe: { 
      handler (newVal) {
        if (!newVal || !newVal.ID) return
        if (this.isLoadingFromBackend) {
          this._syncPrev()
        }
      }, 
      deep: true,
      immediate: true
    },
    // When ID_CLIENTE_NFE changes (destinatário selection), apply Delphi rules
    // IMPORTANTE: Na carga inicial (modo edição), os dados do destinatário vêm do backend
    // (TB_NFE mantém histórico) e não devem ser sobrescritos pelos dados atuais do cadastro
    // de clientes. O watcher só deve processar quando o usuário alterar manualmente.
    'nfe.ID_CLIENTE_NFE': async function (newId, oldId) {
      // REGRA PRINCIPAL: Se está carregando do backend, NÃO processar
      if (this.isLoadingFromBackend) {
        this._syncPrev()
        return
      }
      
      // Se nada mudou, ignorar
      if (oldId === newId) {
        return
      }
      
      console.log('[NfeAbaDestinatario] Processando mudança de destinatário')
      await this.handleDestinatarioChange(newId, oldId)
    }
  },
  computed: {
    cnpjCpfPlaceholder () {
      return this.nfe.OP_TIPO_DOC_DEST === '1' ? '00.000.000/0000-00' : '000.000.000-00'
    },
    ieReadonly () {
      // 1 = Isento → IE bloqueada
      return this.nfe.OP_ICMS_ISENTO_DEST === '1' || this.readonlyFromMaster
    },
    municipioOptions () {
      if (!this.municipios || !this.municipios.length) return []
      return this.municipios.map(m => {
        const id = m.ID || m.id || m.COD || m.IBGE || m.ID_MUNICIPIO || (m.codigo != null ? m.codigo : null)
        const nome = (m.NOME || m.nome || m.DESCRICAO || m.TX_NOME || m.NOME_MUNICIPIO || '').toString()
        return { value: id, text: nome }
      })
    }
  },
  created() {
    this._syncPrev()
  },
  mounted() {
    // Carregar estados e municípios ao montar
    this.getEstados().then(() => {
      const uf = this.nfe && this.nfe.ID_UF_DEST
      if (uf) {
        this.getMunicipiosForUf(uf).catch(() => {})
      }
    }).catch(() => {})
  },
  methods: {
    // --------- inicialização / emissão
    emitInput () {
      // Emitir nfe atualizado
      this.$emit('input', this.nfe)
    },

    // --------- eventos do componente cliente-pesquisa
    async onClienteRetornaId (id) {
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        return
      }
      
      // quando o X é clicado, ClientePesquisa emite null - limpa tudo
      if (id === null || id === '' || id === undefined) {
        this.limparDestinatario()
        return
      }
      // simply set the id; the watcher on nfe.ID_CLIENTE_NFE will perform validation and load details
      this.$set(this.nfe, 'ID_CLIENTE_NFE', id)
      this.emitInput()
    },
    onClienteRetornaNome (display) {
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        return
      }
      
      // quando o X é clicado, ClientePesquisa emite null - já foi limpo em onClienteRetornaId
      if (display === null || display === '' || display === undefined) {
        return
      }
      if (display) {
        // Remove o código do cliente usando a função auxiliar
        const nomeLimpo = this.limparCodigoCliente(display)
        this.$set(this.nfe, 'TX_RAZAO_SOCIAL_DEST', nomeLimpo)
        this.emitInput()
      }
    },
    async onClienteRetornaCGC (cgc) {
      
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        console.log('[NfeAbaDestinatario] Evento ignorado - carregando do backend')
        return
      }
      
      try {
        this.busy = true
        const doc = this.normalizaDoc(cgc)
        this.$set(this.nfe, 'TX_NUM_CNPJ_DEST', doc)
        // define tipo pela quantidade de dígitos
        const currentTipo = this.nfe.OP_TIPO_DOC_DEST
        this.$set(this.nfe, 'OP_TIPO_DOC_DEST', (doc && doc.length === 11) ? '0' : (doc && doc.length === 14 ? '1' : currentTipo))
        this.emitInput()
        if (doc && (doc.length === 11 || doc.length === 14)) {
          const cli = await this.carregarClientePorDocumento(doc) // TODO endpoint real
          if (cli) this.aplicarNoModelo(cli)
        }
      } catch (e) {
        this.toast('Falha ao carregar cliente por documento', 'danger', e)
      } finally {
        this.busy = false
      }
    },
    async onCgcBlur () {
      const doc = this.normalizaDoc(this.nfe.TX_NUM_CNPJ_DEST)
      if (doc.length === 11 || doc.length === 14) {
        await this.onClienteRetornaCGC(doc)
      }
    },

    // ---- Delphi-like rules: on change of destinatário
    _syncPrev () {
      // update stored previous values from current nfe
      this._prevDestId = this.nfe.ID_CLIENTE_NFE || ''
      this._prevDestUf = this.nfe.ID_UF_DEST || ''
    },

    async handleDestinatarioChange (newId, oldId) {
      // Se está carregando do backend, não processar
      if (this.isLoadingFromBackend) {
        this._syncPrev()
        return
      }

      // If nothing changed, skip
      if (newId === oldId) return

      const prevId = this._prevDestId || oldId || ''
      const prevUf = ''

      // If empty selection, just sync prev and exit
      if (!newId) {
        this._syncPrev()
        return
      }

      try {
        this.busy = true
        // Fetch client details from server. Endpoint expected to return object or array
        const resp = await this.$http.get(`/api/protected/clientes/getDetalhesParaVenda/${newId}`)
        // Be tolerant with different axios/legacy wrappers: try resp.data then resp
        let dataCandidate = null
        if (resp == null) dataCandidate = null
        else if (resp.data != null) dataCandidate = resp.data
        else dataCandidate = resp
        const data = Array.isArray(dataCandidate) ? dataCandidate[0] : dataCandidate
        
        const newUf = (data && (data.ID_UF || data.ID_UF_DEST || data.id_uf || data.uf)) || ''

        // UF changes are allowed; parent saves and recalculates item taxes.
        // Verificar se existem produtos através do campo VL_TOTAL_PRODUTOS ou consultando o store
        const temProdutos = Number(this.nfe.VL_TOTAL_PRODUTOS || 0) > 0
        if (false && this.nfe && temProdutos) {
          if (prevUf && newUf && String(prevUf) !== String(newUf)) {
            // Show warning and revert selection (Delphi: messagebox and restore)
            const msg = 'ATENÇÃO !\n\nNão é permitido alterar o Destinatário com a UF do endereço diferente de ' + prevUf + '\n\nTal alteração implicaria na incosistência das alíquotas de ICMS dos produtos já lançados\n\nPara alterar o destinatário exclua todos os produtos!'
            await this.$bvModal.msgBoxOk(msg, { title: 'Aviso', size: 'md', okVariant: 'warning', centered: true })
            // revert
            this.$set(this.nfe, 'ID_CLIENTE_NFE', prevId)
            // restore previous UF if we have it
            if (prevUf) this.$set(this.nfe, 'ID_UF_DEST', prevUf)
            this.emitInput()
            return
          }
        }

        // Apply server details into the model
        if (data) {
          await this.aplicarDetalhesServidor(data)
          await this.$nextTick()
          this._syncPrev()
        } else {
          this.toast('Cliente não encontrado', 'warning')
          // revert to previous id
          this.$set(this.nfe, 'ID_CLIENTE_NFE', prevId)
          this.emitInput()
        }
      } catch (err) {
        this.toast('Falha ao carregar detalhes do cliente', 'danger', err)
        // revert to previous id on error
        this.$set(this.nfe, 'ID_CLIENTE_NFE', prevId)
        this.emitInput()
      } finally {
        this.busy = false
      }
    },

    async aplicarDetalhesServidor (cli) {
      // Map common possible keys returned by backend (adapt as needed)
      const safe = (k) => {
        if (k == null) return ''
        if (typeof k === 'string') return k.trim()
        return k
      }

      // Tipo de Contribuinte: 0-Contribuinte, 1-Isento, 2-Não Contribuinte
      const tipoContribRaw = safe(cli.ISENTO_ICMS || cli.ISENTO)
      const tipoContrib = String(tipoContribRaw) // '0', '1' ou '2'
      const isento = tipoContrib === '1'
      
      const fizJurRaw = safe(cli.FIZ_JUR || cli.FIZJUR || cli.FIZ_JUR)
      const tipoPessoa = String(fizJurRaw) === '1' ? '1' : '0'

      // try common document fields, fallback to scanning RAZAOSOCIAL for numbers
      let cgcRaw = safe(cli.CGC || cli.Cgc || cli.cgc || cli.cnpj || cli.CNPJ || cli.cpf || cli.CPF || '')
      if (!cgcRaw && cli.RAZAOSOCIAL) {
        // try to extract a 11 or 14 digit sequence from RAZAOSOCIAL
        const found = ('' + cli.RAZAOSOCIAL).match(/(\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}|\d{3}\.\d{3}\.\d{3}-\d{2}|\d{14}|\d{11}|\d{2}\d{3}\d{3}\/\d{4}-\d{2})/)
        if (found && found[0]) cgcRaw = found[0]
      }
      const cgc = this.normalizaDoc(cgcRaw || '')

      // Atualizar campos MAIUSCULOS diretamente no nfe
      this.$set(this.nfe, 'ID_CLIENTE_NFE', cli.CODIGO || cli.codigo || cli.id || this.nfe.ID_CLIENTE_NFE)
      const razaoSocial = safe(cli.RAZAOSOCIAL || cli.NOME || cli.nome || this.nfe.TX_RAZAO_SOCIAL_DEST)
      this.$set(this.nfe, 'TX_RAZAO_SOCIAL_DEST', this.limparCodigoCliente(razaoSocial))
      this.$set(this.nfe, 'OP_TIPO_DOC_DEST', tipoPessoa)
      this.$set(this.nfe, 'TX_NUM_CNPJ_DEST', cgc || this.nfe.TX_NUM_CNPJ_DEST)
      // Usar o valor direto do tipo de contribuinte (0, 1 ou 2)
      this.$set(this.nfe, 'OP_ICMS_ISENTO_DEST', tipoContrib || this.nfe.OP_ICMS_ISENTO_DEST)
      this.$set(this.nfe, 'TX_NUM_IE_DEST', isento ? '' : (safe(cli.INS_EST) || safe(cli.INS_ESTADUAL) || safe(cli.IE) || this.nfe.TX_NUM_IE_DEST))
      this.$set(this.nfe, 'TX_NUM_SUFRAMA_DEST', safe(cli.INS_SUFRAMA) || cli.suframa || this.nfe.TX_NUM_SUFRAMA_DEST)
      this.$set(this.nfe, 'TX_EMAIL_DEST', safe(cli.EMAIL1) || safe(cli.EMAIL) || this.nfe.TX_EMAIL_DEST)
      
      // Carregar OP_CONSUMIDOR_FINAL do cliente (0-não, 1-sim)
      const opConsumidor = safe(cli.OP_CONSUMIDOR || cli.OP_CONSUMIDOR_FINAL)
      if (opConsumidor === '0' || opConsumidor === '1') {
        this.$set(this.nfe, 'OP_CONSUMIDOR_FINAL', opConsumidor)
      }
      
      this.$set(this.nfe, 'TX_LOGRADOURO_DEST', safe(cli.ENDERECO) || safe(cli.TX_LOGRADOURO_DEST) || (cli.endereco && safe(cli.endereco.logradouro)) || this.nfe.TX_LOGRADOURO_DEST)
      this.$set(this.nfe, 'TX_NUMERO_DEST', safe(cli.NUMERO) || safe(cli.TX_NUMERO_DEST) || (cli.endereco && safe(cli.endereco.numero)) || this.nfe.TX_NUMERO_DEST)
      this.$set(this.nfe, 'TX_COMPLEMENTO_DEST', safe(cli.COMPLEMENTO) || safe(cli.TX_COMPLEMENTO_DEST) || (cli.endereco && safe(cli.endereco.complemento)) || this.nfe.TX_COMPLEMENTO_DEST)
      this.$set(this.nfe, 'TX_BAIRRO_DEST', safe(cli.BAIRRO) || safe(cli.TX_BAIRRO_DEST) || (cli.endereco && safe(cli.endereco.bairro)) || this.nfe.TX_BAIRRO_DEST)
      this.$set(this.nfe, 'PAIS_DESTINATARIO_ID', safe(cli.PAIS_ID) || this.nfe.PAIS_DESTINATARIO_ID || '1058')
      this.$set(this.nfe, 'TX_PAIS_DEST', safe(cli.PAIS_NOME) || safe(cli.PAIS) || (cli.endereco && safe(cli.endereco.pais)) || this.nfe.TX_PAIS_DEST || 'Brasil')
      
      const uf = safe(cli.ID_UF) || safe(cli.ID_UF_DEST) || (cli.endereco && safe(cli.endereco.uf)) || this.nfe.ID_UF_DEST
      this.$set(this.nfe, 'ID_UF_DEST', uf)
      
      let municipio = safe(cli.ID_MUNICIPIO) || safe(cli.ID_MUNICIPIO_DEST) || (cli.endereco && safe(cli.endereco.municipio)) || this.nfe.ID_MUNICIPIO_DEST
      
      // If we have a UF, try to fetch municipios (behaviour like ClientesEdit.vue)
      if (uf) {
        try {
          await this.getMunicipiosForUf(uf)
          // If backend returned an ID_MUNICIPIO use it; otherwise try to match by name
          if (!municipio && this.municipios && this.municipios.length) {
            // try to find by name (normalized)
            const name = (cli.TX_MUNICIPIO || cli.MUNICIPIO || cli.NOME_MUNICIPIO || '').toString().trim().toUpperCase()
            if (name) {
              const found = this.municipios.find(m => (m.NOME || '').toString().trim().toUpperCase() === name || (m.ID || '').toString() === name)
              if (found) municipio = found.ID || found.id || found.COD || found.IBGE || municipio
            }
          }
        } catch (e) {
          // ignore municipio fetch errors; continue with mapped data
        }
      }
      
      this.$set(this.nfe, 'ID_MUNICIPIO_DEST', municipio)
      this.$set(this.nfe, 'TX_CEP_DEST', safe(cli.CEP) || safe(cli.TX_CEP_DEST) || (cli.endereco && safe(cli.endereco.cep)) || this.nfe.TX_CEP_DEST)
      this.$set(this.nfe, 'TX_FONE_DEST', safe(cli.TELEFONE) || safe(cli.TX_FONE_DEST) || (cli.endereco && safe(cli.endereco.fone)) || this.nfe.TX_FONE_DEST)

      // Apply and emit
      this.readonlyFromMaster = true
      this.emitInput()
      this.$emit('changed')
    },

    // Load list of UFs (estados) from backend and populate ufOptions
    async getEstados () {
      try {
        const resp = await this.$http.get('/api/protected/estados')
        const payload = resp && resp.data ? resp.data : resp
        // payload expected as array of { ID, NOME }
        if (Array.isArray(payload)) {
          const mapped = payload.map(e => {
            // backend may return different field names: prefer ID for value and SIGLA/ESTADO/NOME for text
            const value = (e.ID || e.id || e.sigla || e.codigo || e.ID_UF || e.SIGLA || '').toString()
            let text = (e.SIGLA || e.sigla || e.ESTADO || e.ESTADO_NOME || e.NOME || e.nome || e.DESCRICAO || e.NOME_UF || '').toString()
            if (!text) text = value
            return { value, text }
          })
          this.ufOptions = [{ value: '', text: 'Selecione a UF' }].concat(mapped)
        } else {
          this.ufOptions = [{ value: '', text: 'Selecione a UF' }]
        }
      } catch (e) {
        this.ufOptions = []
      }
    },

    // --------- mudanças de selects / UF
    onTipoDocChange () {
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        return
      }
      
      // origem: Unt_NotaFiscalEletronica.pas: ComboOP_TIPO_DOC_DESTPropertiesChange
      const doc = this.normalizaDoc(this.nfe.TX_NUM_CNPJ_DEST)
      if (this.nfe.OP_TIPO_DOC_DEST === '0' && doc.length === 14) {
        this.$set(this.nfe, 'TX_NUM_CNPJ_DEST', '') // CPF esperado
        this.emitInput()
      }
      if (this.nfe.OP_TIPO_DOC_DEST === '1' && doc.length === 11) {
        this.$set(this.nfe, 'TX_NUM_CNPJ_DEST', '') // CNPJ esperado
        this.emitInput()
      }
    },
    onTipoContribChange () {
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        return
      }
      
      // 1 = Isento → bloqueia e limpa IE
      if (this.nfe.OP_ICMS_ISENTO_DEST === '1') {
        this.$set(this.nfe, 'TX_NUM_IE_DEST', '')
        this.emitInput()
      }
    },
    onUfChange () {
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        return
      }
      
      // se UF mudou, limpar município e carregar lista de municípios
      this.$set(this.nfe, 'ID_MUNICIPIO_DEST', '')
      this.emitInput()
      // async load municipios for selected UF (non-blocking)
      this.getMunicipiosForUf(this.nfe.ID_UF_DEST).catch(() => {})
    },

    // --------- lookup município (stub)
    async onMunicipioLookup () {
      // origem: Unt_NotaFiscalEletronica.dfm: ComboID_MUNICIPIO_ENT
      // TODO: abrir modal/lookup e selecionar município conforme UF
      try {
        this.busy = true
        const lista = await this.pesquisarMunicipio(this.nfe.ID_UF_DEST) // TODO endpoint
        // Exemplo simplificado: pega o primeiro
        if (Array.isArray(lista) && lista.length) {
          this.$set(this.nfe, 'ID_MUNICIPIO_DEST', lista[0].id || '')
          this.emitInput()
        }
      } catch (e) {
        this.toast('Falha ao pesquisar município', 'danger', e)
      } finally {
        this.busy = false
      }
    },

    // Load municipalities for a given UF into `municipios`.
    // Endpoint expected: GET /api/protected/municipios/:uf -> Array of { ID, NOME, ... }
    async getMunicipiosForUf (uf) {
      if (!uf) {
        this.municipios = []
        return
      }
      try {
        this.municipiosBusy = true
        const resp = await this.$http.get(`/api/protected/municipios/${uf}`)
        let payload = null
        if (resp == null) payload = null
        else if (resp.data != null) payload = resp.data
        else payload = resp
        if (Array.isArray(payload)) this.municipios = payload
        else if (payload && Array.isArray(payload.result)) this.municipios = payload.result
        else this.municipios = []
      } catch (e) {
        this.municipios = []
        // intentionally silent; caller can show toast if desired
      } finally {
        this.municipiosBusy = false
      }
    },

    // --------- helpers / integração (stubs)
    normalizaDoc (v) { return (v || '').toString().replace(/\\D+/g, '') },
    
    // Remove o código do cliente da razão social se vier no formato "CODIGO - NOME"
    // Ex: "2277 - BAR E CHURRASCARIA O GAUCHAO" -> "BAR E CHURRASCARIA O GAUCHAO"
    limparCodigoCliente (valor) {
      if (!valor) return ''
      const str = String(valor).trim()
      // Verifica se começa com números seguidos de " - "
      const match = str.match(/^\d+\s*-\s*(.+)$/)
      return match ? match[1].trim() : str
    },
    aplicarNoModelo (cli) {
      // Mapeamento seguro; adapte às chaves reais do seu backend
      const tipoPessoa = cli.cpf ? '0' : '1'
      this.$set(this.nfe, 'ID_CLIENTE_NFE', cli.id || cli.codigo || this.nfe.ID_CLIENTE_NFE)
      const razaoSocial = cli.razao || cli.nome || this.nfe.TX_RAZAO_SOCIAL_DEST
      this.$set(this.nfe, 'TX_RAZAO_SOCIAL_DEST', this.limparCodigoCliente(razaoSocial))
      this.$set(this.nfe, 'OP_TIPO_DOC_DEST', tipoPessoa)
      this.$set(this.nfe, 'TX_NUM_CNPJ_DEST', this.normalizaDoc(cli.cnpj || cli.cpf || this.nfe.TX_NUM_CNPJ_DEST))
      this.$set(this.nfe, 'OP_ICMS_ISENTO_DEST', cli.tipoContribuinte != null ? String(cli.tipoContribuinte) : this.nfe.OP_ICMS_ISENTO_DEST)
      this.$set(this.nfe, 'TX_NUM_IE_DEST', (String(cli.tipoContribuinte) === '1') ? '' : (cli.ie || this.nfe.TX_NUM_IE_DEST))
      this.$set(this.nfe, 'TX_NUM_SUFRAMA_DEST', cli.suframa || this.nfe.TX_NUM_SUFRAMA_DEST)
      this.$set(this.nfe, 'TX_EMAIL_DEST', cli.email || this.nfe.TX_EMAIL_DEST)
      
      // Carregar OP_CONSUMIDOR_FINAL do cliente (0-não, 1-sim)
      const opConsumidor = cli.opConsumidor || cli.OP_CONSUMIDOR || cli.OP_CONSUMIDOR_FINAL
      if (opConsumidor === '0' || opConsumidor === '1' || opConsumidor === 0 || opConsumidor === 1) {
        this.$set(this.nfe, 'OP_CONSUMIDOR_FINAL', String(opConsumidor))
      }
      
      this.$set(this.nfe, 'TX_LOGRADOURO_DEST', cli.endereco?.logradouro || this.nfe.TX_LOGRADOURO_DEST)
      this.$set(this.nfe, 'TX_NUMERO_DEST', cli.endereco?.numero || this.nfe.TX_NUMERO_DEST)
      this.$set(this.nfe, 'TX_COMPLEMENTO_DEST', cli.endereco?.complemento || this.nfe.TX_COMPLEMENTO_DEST)
      this.$set(this.nfe, 'TX_BAIRRO_DEST', cli.endereco?.bairro || this.nfe.TX_BAIRRO_DEST)
      this.$set(this.nfe, 'PAIS_DESTINATARIO_ID', cli.PAIS_ID || cli.endereco?.pais_id || '1058')
      this.$set(this.nfe, 'TX_PAIS_DEST', cli.endereco?.pais || this.nfe.TX_PAIS_DEST || 'Brasil')
      this.$set(this.nfe, 'ID_UF_DEST', cli.endereco?.uf || this.nfe.ID_UF_DEST)
      this.$set(this.nfe, 'ID_MUNICIPIO_DEST', cli.endereco?.municipio || this.nfe.ID_MUNICIPIO_DEST)
      this.$set(this.nfe, 'TX_CEP_DEST', cli.endereco?.cep || this.nfe.TX_CEP_DEST)
      this.$set(this.nfe, 'TX_FONE_DEST', cli.endereco?.fone || this.nfe.TX_FONE_DEST)
      this.readonlyFromMaster = true
      this.emitInput()
      this.$emit('changed')
    },
    async carregarClientePorId (id) {
      // TODO endpoint real
      // Exemplo temporário (mock)
      return null
    },
    async carregarClientePorDocumento (doc) {
      // TODO endpoint real
      // Exemplo temporário (mock)
      return null
    },
    async pesquisarMunicipio (uf) {
      // TODO endpoint real
      return []
    },

    limparDestinatario () {
      this.readonlyFromMaster = false
      this.$set(this.nfe, 'ID_CLIENTE_NFE', '')
      this.$set(this.nfe, 'TX_RAZAO_SOCIAL_DEST', '')
      this.$set(this.nfe, 'OP_TIPO_DOC_DEST', '1')
      this.$set(this.nfe, 'TX_NUM_CNPJ_DEST', '')
      this.$set(this.nfe, 'OP_ICMS_ISENTO_DEST', '0')
      this.$set(this.nfe, 'TX_NUM_IE_DEST', '')
      this.$set(this.nfe, 'TX_NUM_SUFRAMA_DEST', '')
      this.$set(this.nfe, 'TX_EMAIL_DEST', '')
      this.$set(this.nfe, 'TX_LOGRADOURO_DEST', '')
      this.$set(this.nfe, 'TX_NUMERO_DEST', '')
      this.$set(this.nfe, 'TX_COMPLEMENTO_DEST', '')
      this.$set(this.nfe, 'TX_BAIRRO_DEST', '')
      this.$set(this.nfe, 'PAIS_DESTINATARIO_ID', '1058')
      this.$set(this.nfe, 'TX_PAIS_DEST', 'Brasil')
      this.$set(this.nfe, 'ID_UF_DEST', '')
      this.$set(this.nfe, 'ID_MUNICIPIO_DEST', '')
      this.$set(this.nfe, 'TX_CEP_DEST', '')
      this.$set(this.nfe, 'TX_FONE_DEST', '')
      this.emitInput()
      this.$emit('changed')
    },

    toast (msg, variant = 'info', err) {
      const desc = err && (err.message || err.response?.data || err.toString())
      this.$bvToast && this.$bvToast.toast(desc ? `${msg}: ${desc}` : msg, {
        title: 'Destinatário',
        variant,
        autoHideDelay: 3500,
        solid: true
      })
    },


  }
}
</script>

<style scoped>
legend { font-size: 0.95rem; font-weight: 600; }
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeAbaDestinatario.vue